function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SUBMIT_BTN_OPTIONS_KEY } from "./constants";
import getUiOptions from "./getUiOptions";
/** The default submit button options, exported for testing purposes
 */

export var DEFAULT_OPTIONS = {
  props: {
    disabled: false
  },
  submitText: 'Submit',
  norender: false
};
/** Extracts any `ui:submitButtonOptions` from the `uiSchema` and merges them onto the `DEFAULT_OPTIONS`
 *
 * @param [uiSchema={}] - the UI Schema from which to extract submit button props
 * @returns - The merging of the `DEFAULT_OPTIONS` with any custom ones
 */

export default function getSubmitButtonOptions() {
  var uiSchema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uiOptions = getUiOptions(uiSchema);

  if (uiOptions && uiOptions[SUBMIT_BTN_OPTIONS_KEY]) {
    var options = uiOptions[SUBMIT_BTN_OPTIONS_KEY];
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }

  return DEFAULT_OPTIONS;
}